

import { defineComponent } from "vue";
import { mapState, mapStores } from "pinia";

import DashboardGrid from '~/components/dashboard-grid.vue';
import DashboardHeader from './dashboard-header.vue';
import BasePage from '~/core/base-page';

import { useStationStore } from "~/store/station.store";
import { useDashboardStore } from "~/store/dashboard.store";
import { useWidgetStore } from "~/store/widgets.store";


export default defineComponent({

    extends: BasePage,

    components: {
        DashboardGrid,
        DashboardHeader,
    },

    async mounted(): Promise<void> {
        try {
            await this.widgetStore.load();
            await this.stationStore.fetchStations();
            await this.stationStore.fetchStationGroups();

            if(!this.stationStore.allStations || !this.stationStore.allStations.length) {
                this.$router.push({name: 'add-station'});
                return;
            }
    
            if(this.$route.query?.mode && ['hour', 'day', 'week', 'month'].includes(this.$route.query?.mode as string)) {
                this.dashboardStore.mode = this.$route.query.mode as 'hour' | 'day' | 'week' | 'month';
            }
    
            if(this.$route.query?.indicator) {
                this.dashboardStore.indicator = this.$route.query.indicator as string;
            }

            if(this.$route?.query?.station && !this.isStationAllowed(this.$route?.query?.station)) {
                this.$router.push('/403')
            }
    
            if(this.$route.query?.station) {
                this.dashboardStore.selectStation(
                    Array.isArray(this.$route.query?.station) ? this.$route.query?.station[0]: this.$route.query?.station
                );
            } else {
                this.dashboardStore.selectStation();
            }

            document.addEventListener('visibilitychange', this.handleVisibilityChange);
        } catch(e) {
            this.showUnhandledError(`Could not init dashboard. Failed to fetch station`, e);
        }
    },
    
    unmounted() {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    },

    methods: {
        /**
         * Handle document visibilitychange event. Refresh dashboard if tab is active.
         */
        handleVisibilityChange(): void {
            if(document.visibilityState === 'visible') {
                try {
                    this.dashboardStore.refresh();
                } catch(error) {
                    this.showUnhandledError('Could not refresh', error);
                }
            }
        },
    },

    computed: {
        ...mapStores(useStationStore, useDashboardStore, useWidgetStore),
        ...mapState(useWidgetStore, ['widgets']),
    },

    watch: {
        async $route(to: {query: Record<string, string | string[]>, path: string}, from:{query: Record<string, string[]|string>, path: string}) {
            let shouldUpdate: boolean = true;
            if(!to.path.includes('dashboard')){
                return;
            }
            
            if(to?.query?.indicator && to?.query?.indicator !== from?.query?.indicator) {
                this.dashboardStore.indicator = to.query.indicator;
                shouldUpdate = false;
            }

            if(to?.query?.mode && to?.query?.mode !== from?.query?.mode) {
                this.dashboardStore.mode = to?.query?.mode;
            }

            if(to?.query?.station && !this.isStationAllowed(to?.query?.station)) {
                this.$router.push('/403')
            }
            if(to?.query?.station && to?.query?.station !== from?.query?.station) {
                this.dashboardStore.selectStation(
                    Array.isArray(this.$route.query?.station) ? this.$route.query?.station[0]: this.$route.query?.station
                );
                shouldUpdate = true;
            } 
            
            if(shouldUpdate) {
                try {
                    this.dashboardStore.refresh();
                } catch(error) {
                    this.showUnhandledError('Could not refresh', error);
                }
            }
        },
    }
})

